import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhLoaderComponent } from '@shared/components/ph-loader/ph-loader.component';

@NgModule({
  declarations: [PhLoaderComponent],
  exports: [PhLoaderComponent],
  imports: [CommonModule],
})
export class PhLoaderModule {}
